<template>
  <app-data-editor
    :id="id"
    title="Редактирование торговой марки"
    resource="trademarks"
    :elements="elements"
    add-message="Торговая марка добавлена"
    edit-message="Торговая марка изменена"
    @change="payload => (isChanged = payload)"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v => {
                  const pattern = /[^,\s."']/g;
                  return (
                    pattern.test(v.charAt(0)) ||
                    v === "" ||
                    "Наименование не может начинаться c пробела, кавычек, точки или запятой"
                  );
                },
              ],
            },
            default: "",
          },
          {
            title: "Производитель",
            name: "manufacturer",
            control: {
              type: "reference",
              component: "Manufacturer",
              resource: "manufacturers",
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
      ],
    };
  },
};
</script>
